import React from "react";

function LoadingForm() {
  return (
    <div className="check-booking-form-bg">
      <div className="check-booking-form-container-loader">
        <div className="booking-form-loader-style">
          <div className="loader-form"></div>
        </div>
      </div>
    </div>
  );
}

export default LoadingForm;
